import { useCallback } from "react";
import { useIntl } from "react-intl";

export const useGetStatisticFieldLabel = () => {
  const { formatMessage, messages } = useIntl();

  return useCallback(
    (statisticField: string) => {
      const translationKey = `stats.full.${statisticField}`;

      return messages[translationKey] ? formatMessage({ id: translationKey }) : statisticField;
    },
    [formatMessage, messages],
  );
};
